// SEO Area Configuration
export const areaConfig = {
  stellenbosch: {
    name: 'Stellenbosch',
    slug: 'stellenbosch',
    region: 'Winelands',
    nearby: ['Somerset West', 'Paarl', 'Franschhoek', 'Strand', 'Gordons Bay'],
    description: 'Student accommodation moves, furniture delivery, and same-day courier service in Stellenbosch',
    specialties: ['Student moves', 'University accommodation', 'Wine estate deliveries', 'Town center pickups'],
    accessNotes: 'Campus access varies by residence. Some areas have parking restrictions during peak student move times.',
    coordinates: { lat: -33.9321, lng: 18.8602 }
  },
  'somerset-west': {
    name: 'Somerset West',
    slug: 'somerset-west',
    region: 'Helderberg',
    nearby: ['Strand', 'Gordons Bay', 'Stellenbosch', 'Cape Town CBD'],
    description: 'Mini-moves, furniture delivery, and local courier services in Somerset West',
    specialties: ['Estate moves', 'Apartment relocations', 'Shopping center pickups', 'Helderberg connections'],
    accessNotes: 'Many estates have access control. Please provide gate codes or notify security in advance.',
    coordinates: { lat: -34.0781, lng: 18.8431 }
  },
  'cape-town-cbd': {
    name: 'Cape Town CBD',
    slug: 'cape-town-cbd',
    region: 'City Bowl',
    nearby: ['Green Point', 'Sea Point', 'Woodstock', 'Observatory', 'Gardens'],
    description: 'Fast CBD deliveries, apartment moves, and business courier service in Cape Town city center',
    specialties: ['High-rise apartments', 'Business deliveries', 'Restaurant supplies', 'Office moves'],
    accessNotes: 'CBD parking is limited. Loading zones available but may require advance booking with building management.',
    coordinates: { lat: -33.9249, lng: 18.4241 }
  },
  paarl: {
    name: 'Paarl',
    slug: 'paarl',
    region: 'Winelands',
    nearby: ['Wellington', 'Franschhoek', 'Stellenbosch', 'Durbanville'],
    description: 'Furniture moves, wine deliveries, and local courier service in Paarl',
    specialties: ['Wine farm deliveries', 'Residential moves', 'Industrial area pickups', 'Estate connections'],
    accessNotes: 'Wine estates may require advance booking. Some farms have specific delivery time windows.',
    coordinates: { lat: -33.7141, lng: 18.9644 }
  },
  'northern-suburbs': {
    name: 'Northern Suburbs',
    slug: 'northern-suburbs',
    region: 'Northern Suburbs',
    nearby: ['Bellville', 'Durbanville', 'Parow', 'Goodwood', 'Brackenfell'],
    description: 'Mini-moves and deliveries across Cape Town Northern Suburbs',
    specialties: ['Shopping center pickups', 'Residential moves', 'Business park deliveries', 'Industrial area connections'],
    accessNotes: 'Business parks often have loading bays. Residential estates have access control systems.',
    coordinates: { lat: -33.8913, lng: 18.6283 }
  },
  'southern-suburbs': {
    name: 'Southern Suburbs',
    slug: 'southern-suburbs',
    region: 'Southern Suburbs',
    nearby: ['Constantia', 'Wynberg', 'Claremont', 'Muizenberg', 'Fish Hoek'],
    description: 'Furniture moves and deliveries in Cape Town Southern Suburbs',
    specialties: ['Upmarket estate moves', 'University student accommodation', 'Coastal connections', 'Shopping center pickups'],
    accessNotes: 'Many areas have steep access roads. Some properties have long driveways or stairs.',
    coordinates: { lat: -34.0178, lng: 18.4695 }
  }
};

export const generateAreaFAQs = (areaName) => {
  return [
    {
      question: `Do you offer same-day delivery in ${areaName}?`,
      answer: `Yes! We offer Rocket Van NOW (urgent on-demand) and Rocket Van TODAY (same-day scheduled) services in ${areaName}, subject to availability. Contact us on WhatsApp for real-time availability.`
    },
    {
      question: `What areas near ${areaName} do you serve?`,
      answer: `We connect ${areaName} to all major areas including Stellenbosch, Cape Town CBD, Somerset West, and the greater Western Cape region.`
    },
    {
      question: `How much does a mini-move cost in ${areaName}?`,
      answer: `Pricing depends on distance, load size, helpers needed, and access (stairs, parking). For ${areaName} moves, typical costs start from R350 for small loads. Get an exact quote on WhatsApp or use our quote form.`
    },
    {
      question: `Can you handle stairs and no-lift apartments in ${areaName}?`,
      answer: `Yes! We handle stairs and no-lift access regularly in ${areaName}. We'll add the appropriate number of helpers and adjust pricing fairly based on floors and load.`
    },
    {
      question: `Do you move furniture between ${areaName} and other areas?`,
      answer: `Absolutely! We regularly move furniture, appliances, and household items between ${areaName} and all major areas including Stellenbosch, Cape Town, Somerset West, and beyond.`
    },
    {
      question: `What's the best way to get a quote for ${areaName}?`,
      answer: `WhatsApp us your pickup and drop-off locations, what you need moved, and your preferred date. We'll send you a clear quote within minutes. Alternatively, use our online quote form.`
    },
    {
      question: `Do you provide helpers for loading and unloading in ${areaName}?`,
      answer: `Yes! Choose from driver-only, driver + 1 helper, or driver + 2 helpers depending on your load size and whether you have stairs or heavy items.`
    },
    {
      question: `How do I track my delivery in ${areaName}?`,
      answer: `We send real-time WhatsApp updates throughout your delivery, plus photo proof-of-delivery when complete. You'll always know where your items are.`
    }
  ];
};

export default areaConfig;
